import { useState, useEffect } from 'react'
import axios from 'axios'
import configs from '../../config'
import { useInterval } from '../../hooks'
import { useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'

import { Button, Card, Table } from 'react-bootstrap'

const defaultPrize = {
  first: 0,
  second: 0,
  third: 0,
  fourth: 0,
  fifth: 0,
  last2Digits: 0,
  last3Digits: 0,
  first3Digits: 0,
  nearBy: 0,
}

// 10 secs
const DELAY = 10000

const PrizeSummary = () => {
  const history = useHistory()
  const { roundDate } = useSelector((state) => state.webConfig)
  const [foundPrize, setFoundPrize] = useState(defaultPrize)
  const [totalPrize, setTotalPrize] = useState(defaultPrize)

  useInterval(() => {
    const fetchPrize = async () => {
      try {
        const response = await axios.get(`${configs.adminApiGateway}/api/v1/admin/prizes/summary/round/${roundDate}`)
        const { totalPrize: prizes, prizeItem } = response.data.data
        setFoundPrize(prizeItem)
        setTotalPrize(prizes)
      } catch (err) {
        console.log(err)
      }
    }

    fetchPrize()
  }, DELAY)

  useEffect(() => {
    if (roundDate) {
      const fetchPrize = async () => {
        try {
          const response = await axios.get(`${configs.adminApiGateway}/api/v1/admin/prizes/summary/round/${roundDate}`)
          const { totalPrize: prizes, prizeItem } = response.data.data
          setFoundPrize(prizeItem)
          setTotalPrize(prizes)
        } catch (err) {
          console.log(err)
        }
      }

      fetchPrize()
    }
  }, [roundDate])

  return (
    <Card>
      <Card.Header>
        <Card.Title>Prize Summary</Card.Title>
      </Card.Header>
      <Card.Body>
        <Table responsive striped className="text-center">
          <thead>
            <tr>
              {Object.keys(defaultPrize).map((k) => {
                return <th key={k}>{k}</th>
              })}
            </tr>
          </thead>
          <tbody>
            <tr>
              {Object.keys(foundPrize).map((k) => {
                return <td key={`table-${k}`}>{`${foundPrize[k]} / ${totalPrize[k]}`}</td>
              })}
            </tr>
          </tbody>
        </Table>
        <Button
          onClick={() => {
            history.push('/recheckPrizes')
          }}
        >
          กลับ
        </Button>
      </Card.Body>
    </Card>
  )
}

export default PrizeSummary
